import {
  Alert, Box, styled, Typography,
} from '@worthy-npm/worthy-common-ui-components';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import dayjs from 'dayjs';
import { PromoDetails } from '../../data/promotion';
import { useAppSelector } from '../../app/hooks';
import { selectUser, selectWizard } from '../../slices/submitSlice';
import { isPromoExperiment } from '../../lib/experiment';

const bannerTitleText = {
  control: 'Success Fee Lowered to 5% When You Ship by',
  variant: 'Payout Increased to 95% When You Ship by',
};

const BannerWrapper = styled(Alert)(({ theme }) => ({
  backgroundImage: 'url(\'images/promotion/banner.png\')',
  borderRadius: 0,
  color: theme.palette.common.white,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& .MuiAlert-message': {
    flex: 1,
  },
}));

const BannerContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '12px',
  [theme.breakpoints.down('md')]: {
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '8px',
  },
}));

function PromoBanner() {
  const user = useAppSelector(selectUser);

  const [isBannerVisible, setBannerVisible] = useState(false);
  const [bannerText, setBannerText] = useState('');
  const promoBanner = 1;
  const { currentVertexId } = useAppSelector(selectWizard);

  useEffect(() => {
    const bannerClosed = !!localStorage.getItem(PromoDetails.sessionStorageKey);
    if (bannerClosed || !user) {
      setBannerVisible(false);
      return;
    }

    const creationDate = user?.created_at;

    if (!creationDate) {
      setBannerVisible(false);
      return;
    }

    const createdDate = dayjs(creationDate);
    const currentDate = dayjs();
    const daysDifference = currentDate.diff(createdDate, 'day');

    if (daysDifference > 14) {
      setBannerVisible(false);
      return;
    }

    if (promoBanner == null) {
      setBannerVisible(false);
      return;
    }
    const isCorrectLoaction = _.isEmpty(PromoDetails.onlyForSteps)
      || PromoDetails.onlyForSteps.includes(currentVertexId || '');
    if (!isCorrectLoaction) {
      setBannerVisible(false);
      return;
    }

    const titles = bannerTitleText;
    const baseText = titles.control;

    const endDate = createdDate.add(daysDifference > 7 ? 14 : 7, 'day').format('MM.DD');

    setBannerText(`${baseText} ${endDate}`);
    setBannerVisible(true);
  }, [user, promoBanner, currentVertexId]);

  const onClose = () => {
    localStorage.setItem(PromoDetails.sessionStorageKey, 'true');
    setBannerVisible(false);
  };

  if (!isBannerVisible) {
    return null;
  }

  return (
    <BannerWrapper icon={false} onClose={onClose}>
      <BannerContent>
        <Typography variant="h5" fontWeight="300">
          Limited Time Offer:
        </Typography>
        <Typography variant="h3">{bannerText}</Typography>
      </BannerContent>
    </BannerWrapper>
  );
}

export default PromoBanner;
